// firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

// Configuração Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCgnOKYrFVY77AFqxN50-gn_YDXiTKnGQA",
  authDomain: "karaoke-3d79e.firebaseapp.com",
  databaseURL: "https://karaoke-3d79e-default-rtdb.firebaseio.com", // Certifique-se de usar o databaseURL correto
  projectId: "karaoke-3d79e",
  storageBucket: "karaoke-3d79e.appspot.com",
  messagingSenderId: "37344959466",
  appId: "1:37344959466:web:db24cbb45b6c9b16e23093",
};

// Inicializa Firebase e Realtime Database
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database };
